export const TOTAL_STEPS = 2;
